import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const copyShopifyIntegration = unaryRpc({
  name: "copyShopifyIntegration",
  input: z.object({
    sourceTeamId: zExt.objectId(),
    destinationTeamId: zExt.objectId(),
  }),
  output: z.object({ success: z.boolean(), message: z.string() }),
});
